<template>
  <div>
    <v-card min-width="400">
      <v-list-item three-line>
        <v-list-item-content>
          <v-list-item>Кол-во ДТП: {{ MARKERS_COUNTER }}</v-list-item>
          <v-list-item
            >Кол-во мест концентрации: {{ CLUSTERS_COUNTER }}</v-list-item
          >
          <v-list-item> Статус места концентрации: </v-list-item>
          <v-list-item class="mt-n4">
            <v-select
              v-model="clustersChecked"
              :items="itemsChecked"
              menu-props="auto"
              label="Все"
              hide-details
              prepend-icon="fa-check-square"
              single-line
            ></v-select>
          </v-list-item>
          <v-list-item> Местоположение: </v-list-item>
          <v-list-item class="mt-n4">
            <v-select
              v-model="clustersLocation"
              :items="itemsLocation"
              menu-props="auto"
              label="Все"
              hide-details
              prepend-icon="fa-map-marked-alt"
              single-line
            ></v-select>
          </v-list-item>
          <v-list-item>
            <v-text-field
            class="mt-3"
            label="Номер места концентрации"
            v-model="clusterNumber"
          ></v-text-field>
          </v-list-item>
        </v-list-item-content>
      </v-list-item>
      <v-card-actions
        ><v-btn :color="btn" @click="showClusters">Показать</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      btn: "white",
      clusterNumber: '',
      item: [],
      clustersChecked: '',
      itemsChecked: [
        {text: "Проверен", value: true},
        { text: "Не проверен", value: false}
        ],
      clustersLocation: '',
      itemsLocation: ["Город", "Загород", "Другое"]
    };
  },
  methods: {
    ...mapActions(["GET_CLUSTER", "FILTER_CLUSTERS", "GET_FOCUS_COORD"]),
    showClusters() {
      this.clusterNumber.trim();
      if (this.clusterNumber !== "") {
        if (parseInt(this.clusterNumber) > 0){
        this.GET_CLUSTER(this.clusterNumber);
        }
      } else {
        this.$store.dispatch("GET_CLUSTERS", {location: this.clustersLocation, status: this.clustersChecked});
      }
    }
  },
  computed: {
    ...mapGetters(["MARKERS_COUNTER","CLUSTERS_COUNTER","SELECTED_CLUSTER"])
  },
};
</script>

<style></style>
